export const GET_STOP_LIGHT_COLOR_DATA_REQUEST = "GET_STOP_LIGHT_COLOR_DATA_REQUEST";
export const GET_STOP_LIGHT_COLOR_DATA_SUCCESS = "GET_STOP_LIGHT_COLOR_DATA_SUCCESS";
export const GET_STOP_LIGHT_COLOR_DATA_FAILURE = "GET_STOP_LIGHT_COLOR_DATA_FAILURE";

export const UPDATE_STOP_LIGHT_COLOR_REQUEST = "UPDATE_STOP_LIGHT_COLOR_REQUEST";
export const UPDATE_STOP_LIGHT_COLOR_SUCCESS = "UPDATE_STOP_LIGHT_COLOR_SUCCESS";
export const UPDATE_STOP_LIGHT_COLOR_FAILURE = "UPDATE_STOP_LIGHT_COLOR_FAILURE";

export const ADD_STOP_LIGHT_COLOR_REQUEST = "ADD_STOP_LIGHT_COLOR_REQUEST";
export const ADD_STOP_LIGHT_COLOR_SUCCESS = "ADD_STOP_LIGHT_COLOR_SUCCESS";
export const ADD_STOP_LIGHT_COLOR_FAILURE = "ADD_STOP_LIGHT_COLOR_FAILURE";

export const DELETE_STOP_LIGHT_COLOR_REQUEST = "DELETE_STOP_LIGHT_COLOR_REQUEST";
export const DELETE_STOP_LIGHT_COLOR_SUCCESS = "DELETE_STOP_LIGHT_COLOR_SUCCESS";
export const DELETE_STOP_LIGHT_COLOR_FAILURE = "DELETE_STOP_LIGHT_COLOR_FAILURE";

export const GET_STOP_LIGHT_SYSTEM_DATA_REQUEST = "GET_STOP_LIGHT_SYSTEM_DATA_REQUEST";
export const GET_STOP_LIGHT_SYSTEM_DATA_SUCCESS = "GET_STOP_LIGHT_SYSTEM_DATA_SUCCESS";
export const GET_STOP_LIGHT_SYSTEM_DATA_FAILURE = "GET_STOP_LIGHT_SYSTEM_DATA_FAILURE";

export const UPDATE_STOP_LIGHT_SYSTEM_REQUEST = "UPDATE_STOP_LIGHT_SYSTEM_REQUEST";
export const UPDATE_STOP_LIGHT_SYSTEM_SUCCESS = "UPDATE_STOP_LIGHT_SYSTEM_SUCCESS";
export const UPDATE_STOP_LIGHT_SYSTEM_FAILURE = "UPDATE_STOP_LIGHT_SYSTEM_FAILURE";

export const ADD_STOP_LIGHT_SYSTEM_REQUEST = "ADD_STOP_LIGHT_SYSTEM_REQUEST";
export const ADD_STOP_LIGHT_SYSTEM_SUCCESS = "ADD_STOP_LIGHT_SYSTEM_SUCCESS";
export const ADD_STOP_LIGHT_SYSTEM_FAILURE = "ADD_STOP_LIGHT_SYSTEM_FAILURE";

export const DELETE_STOP_LIGHT_SYSTEM_REQUEST = "DELETE_STOP_LIGHT_SYSTEM_REQUEST";
export const DELETE_STOP_LIGHT_SYSTEM_SUCCESS = "DELETE_STOP_LIGHT_SYSTEM_SUCCESS";
export const DELETE_STOP_LIGHT_SYSTEM_FAILURE = "DELETE_STOP_LIGHT_SYSTEM_FAILURE";
